import IGetIssueIdOrKeyReducer from "../reducers/interfaces/iGetIssueIdOrKeyReducer";

const getIssueIdOrKey = (store: any) => store.get("jiraMetadata").toJS() as IGetIssueIdOrKeyReducer;

const generateUsernamesSelectors = {
    loading: (store: any) => getIssueIdOrKey(store).loading,
    jiraMetadata: (store: any) => getIssueIdOrKey(store).jiraMetadata
};

export default generateUsernamesSelectors;